/* eslint-disable prefer-destructuring */
export default Engine =>
    class Recover extends Engine {
        moneyManagementParams = {
            initial   : 0,
            maxSteps  : 20,
            profit    : 1,
            startAfter: 0,
            stake     : 0,
            steps     : 0,
            total     : 0,
        };

        recoverAfterPurchase = details => {
            const corePayout = this.actualContract.payout - this.actualContract.buy_price;
            const { profit, maxSteps, startAfter } = this.moneyManagementParams;
            const payout = corePayout / this.moneyManagementParams.stake;

            if (details[3] < 0) {
                this.moneyManagementParams.total += this.moneyManagementParams.stake;
                this.moneyManagementParams.steps++;
                if (
                    this.moneyManagementParams.steps >= Number(maxSteps) ||
                    this.moneyManagementParams.steps < Number(startAfter)
                ) {
                    this.recoverReset();
                } else {
                    this.moneyManagementParams.stake = Number(
                        ((this.moneyManagementParams.total / payout) * (1 + (profit > 0 ? profit / 100 : 0))).toFixed(2)
                    );

                    // (0,35 / ((0,1 / 0,35) )) * (1 + 0,27)

                    // (this.moneyManagementParams.total / ((corePayout / this.moneyManagementParams.stake) )) * (1 + (profit > 0 ? profit / 100 : 0))
                }
            } else {
                this.recoverReset();
            }
        };

        recoverStake = () => this.moneyManagementParams.stake;

        recoverTradeDefinitions = args => {
            this.moneyManagementParams = { ...args, steps: 0, total: 0, stake: args.initial };
        };

        recoverReset = () => {
            this.moneyManagementParams.total = 0;
            this.moneyManagementParams.steps = 0;
            this.moneyManagementParams.stake = this.moneyManagementParams.initial;
        };
    };
